var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewCart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 113,
    viewBox: "0 0 177 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.448 -79.6289C139.909 -31.2951 105.258 70.2032 -21.0332 89.5264",
    stroke: "#E37B00",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.114 -45.4195C157.576 -0.755742 89.2592 81.9206 -35.7015 55.316",
    stroke: "#032A4B",
    strokeDasharray: "4 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewCart2);
export default __webpack_public_path__ + "static/media/overview-cart-2.9ee4ff9198d9e231ea412d9348ac097d.svg";
export { ForwardRef as ReactComponent };